import { Component, Input } from '@angular/core';
import { CerrixSubtitleComponent } from '@app/shared/atoms/cerrix-subtitle/cerrix-subtitle.component';
import { CerrixTitleComponent } from '@app/shared/atoms/cerrix-title/cerrix-title.component';

@Component({
  selector: 'cerrix-header',
  templateUrl: './cerrix-header.component.html',
  styleUrls: ['./cerrix-header.component.scss'],
  imports: [
    CerrixTitleComponent,
    CerrixSubtitleComponent
  ]
})
export class CerrixHeaderComponent{
 @Input() title : string;
 @Input() subTitle : string;

}
